export default __webpack_public_path__ + "static/media/bp.c5f86f97.svg";